module.exports = __webpack_public_path__ + "img/icon-money.dd706bfc.svg";